import { ReactElement, useContext } from 'react';
import { Heading } from '@appsumo/dorado-react';

import { DEALS_HEADER_TITLE_LIST } from '~/constants/cart';
import { CartContext } from '~/contexts/cart';
import { CartItemProps, CartCouponProps } from '~/types/cart';

import { KlarnaMessage } from '~/components/global/KlarnaMessage';
import { DealItemList, DealHeader } from '~/components/cart';

export default function Deals({
  cartItems,
  hasPlusInCart,
}: {
  cartItems?: CartItemProps[];
  hasPlusInCart: boolean;
}): ReactElement {
  const { billingDetails, user, cart } = useContext(CartContext);

  const headerEl = hasPlusInCart ? (
    <Heading.H2 className="leading-6">Deals</Heading.H2>
  ) : null;
  const itemsContainerClassName = !hasPlusInCart
    ? '[&>div:nth-child(2)]:mt-0 lg:[&>div:nth-child(2)]:!mt-4'
    : '';

  if (!cartItems?.length) return <></>;

  const couponData = {
    ...cart?.coupon,
    description: cart?.coupon_desc,
  } as CartCouponProps;

  return (
    <div
      className="lg:col-start-1 lg:col-end-1"
      data-testid="cart-deals-container"
    >
      <div className="rounded border border-sundog p-4 lg:p-6">
        {headerEl}
        <div className={itemsContainerClassName}>
          <div className="mt-4 hidden border-b border-sundog pb-2 text-grace lg:grid lg:grid-cols-[minmax(200px,_1fr)_minmax(200px,_1fr)_100px_90px] lg:gap-x-6">
            <DealHeader titleList={DEALS_HEADER_TITLE_LIST} />
          </div>
          <DealItemList
            cartItems={cartItems}
            user={user}
            hasPlusInCart={hasPlusInCart}
            couponData={couponData}
          />
        </div>
      </div>
      {/* Since klarna will dynamically show, easier to to show it here instead as a grid item */}
      {!hasPlusInCart && (
        <KlarnaMessage
          className="mt-4 hidden lg:block"
          currentBillingCountry={
            `${billingDetails?.country?.value}` || billingDetails?.geoIPCountry
          }
        />
      )}
    </div>
  );
}

export { Deals };
